import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';
import Navbar2 from '../Navbar2';
import './SearchResults.css';
import Footer from '../Footer/Footer';

function SearchResults() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);
    const query = searchParams.get('q');
    const brand = searchParams.get('brand');

    useEffect(() => {
        

        const fetchResults = async () => {
            try {
                let url = 'http://localhost:3001/api/search';
                if(brand) {
                    url = `http://localhost:3001/api/products?brand=${encodeURIComponent(brand)}`;
                } else if (query) {
                    url = `http://localhost:3001/api/search?q=${encodeURIComponent(query)}`;
                }

                const response = await fetch(url);
                const data = await response.json();
                setProducts(data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching search results:", error);
                setLoading(false);
            }
        }
        fetchResults();
    }, [location.search, query, brand]);

    if(loading) {
        return (
            <>
                <Navbar />
                <div className="sticky-navbar">
                    <Navbar2 />
                </div>
                <div className="search-results-loading">
                    <div className="spinner-border" 
                        role="status"
                        style={{width: "3rem", height: "3rem"}}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <Navbar />
            <div className="sticky-navbar">
                <Navbar2 />
            </div>
            <h4>Search Resullt</h4>
            <div className='search-results-container'>
                <div className="search-results-header">
                    <h2>Search Results for "{query}"</h2>
                    {products.length === 0 && (
                        <p className="no-results">No products found matching your search.</p>
                    )}
                </div>
                
                <div className="search-results-grid">
                    {products.map(product => (
                        <div 
                            className="search-result-card"
                            key={product._id} 
                            onClick={() => navigate(`/product/${product._id}`)}
                        >
                            <div className="card h-100">
                                <div className="search-result-image">
                                    {product.images && product.images.length > 0 && (
                                        <img 
                                            src={`http://localhost:3001/uploads/${product.images[0]}`}
                                            className="card-img-top"
                                            alt={product.description}
                                        />
                                    )}
                                </div>
                                <div className="card-body">
                                        <h5 className="card-title">{product.brand} - {product.productType}</h5>
                                        <p className="card-text">₹{product.price.discounted} 
                                            <span className="text-muted text-decoration-line-through ms-2">₹{product.price.actual}</span>
                                        </p>
                                </div>
                               
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Footer/>
        </>
    )
}

export default SearchResults